import type { AlimTalkTemplate, AlimTalkTemplateBlueprint, NotificationBenefitKind } from "../../../api/services/notification-center.service";

export const BENEFIT_LABELS: Record<NotificationBenefitKind, string> = {
  coupon: "할인쿠폰", voucher: "무료쿠폰", precoupon: "예약권",
};

// Manual receipt notices, deliberately separate from automatic system events.
export const BENEFIT_TEMPLATE_BLUEPRINTS: AlimTalkTemplateBlueprint[] = (
  Object.entries(BENEFIT_LABELS) as [NotificationBenefitKind, string][]
).map(([kind, label]) => ({
  event_type: `benefit_${kind}_receipt`,
  event_label: `이벤트 참여 완료 · ${label} 수령 안내`,
  category: "usage",
  template_code: `EVENT_${kind.toUpperCase()}_RECEIPT`,
  template_name: `이벤트 참여 ${label} 수령 안내`,
  template_content: `#{camp_name}\n#{username}님, #{event_name} 참여가 완료되어 ${label} 수령 방법을 안내드립니다.\n\n■ 혜택명: #{${kind}_name}\n\n참여 시 안내된 혜택을 아래 버튼에서 확인하고 받아 주세요.\n\n이 메시지는 이벤트 참여를 완료하여 혜택 수령 대상이 된 고객님께 발송됩니다.`,
  template_type: "BA",
  category_code: "009005",
  is_secure_template: false,
  buttons: [{ name: `${label} 받기`, type: "WL", url_mobile: `https://#{${kind}_url}`, url_pc: `https://#{${kind}_url}` }],
  ordered_variables: ["camp_name", "username", "event_name", `${kind}_name`, `${kind}_url`],
}));

export function httpsPrefixedBenefitKeys(template: AlimTalkTemplate | null): string[] {
  return [...new Set((template?.buttons || []).flatMap((button) => [button.url_mobile, button.url_pc])
    .flatMap((url) => url?.match(/^https:\/\/#\{((?:coupon|voucher|precoupon)_url)\}$/i)?.[1] || []))];
}

export function receiptEventVariableKey(keys: string[]): string | undefined {
  const benefitKeys = Object.keys(BENEFIT_LABELS).flatMap((kind) => [`${kind}_name`, `${kind}_url`]);
  return keys.some((key) => benefitKeys.includes(key.toLowerCase())) ? keys.find((key) => key.toLowerCase() === "event_name") : undefined;
}

export function benefitVariableValues(keys: string[], kind: NotificationBenefitKind, benefit?: { name: string; url: string }, httpsKeys: string[] = []) {
  return Object.fromEntries(keys.filter((key) => [`${kind}_name`, `${kind}_url`].includes(key.toLowerCase()))
    .map((key) => [key, benefit ? (key.toLowerCase().endsWith("_url")
      ? (httpsKeys.includes(key) ? benefit.url.replace(/^https:\/\//i, "") : benefit.url) : benefit.name) : ""]));
}
